import { render } from "./TitleWrapper.vue?vue&type=template&id=746b6432&scoped=true"
import script from "./TitleWrapper.vue?vue&type=script&lang=js"
export * from "./TitleWrapper.vue?vue&type=script&lang=js"

import "./TitleWrapper.vue?vue&type=style&index=0&id=746b6432&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746b6432"]])

export default __exports__